import * as constants from "./constants";

export const fetchCommodities = (data) => {
  return {
    type: constants.FETCH_COMMODITIES,
    data,
  };
};

export const fetchCommoditiesSuccess = (data) => {
  return {
    type: constants.FETCH_COMMODITIES_SUCCESS,
    data: data,
  };
};

export const fetchCommoditiesError = (data) => {
  return {
    type: constants.FETCH_COMMODITIES_ERROR,
    data: data,
  };
};

export const updateCommodity = (data) => {
  return {
    type: constants.UPDATE_COMMODITIES,
    data: data,
  };
};

export const updateCommoditySuccess = (data) => {
  return {
    type: constants.UPDATE_COMMODITIES_SUCCESS,
    data: data,
  };
};

export const updateCommodityError = () => {
  return {
    type: constants.UPDATE_COMMODITIES_ERROR,
  };
};

export const deleteCommodity = (data) => {
  return {
    type: constants.DELETE_COMMODITIES,
    data: data,
  };
};

export const deleteCommoditySuccess = (data) => {
  return {
    type: constants.DELETE_COMMODITIES_SUCCESS,
    data: data,
  };
};

export const deleteCommodityError = () => {
  return {
    type: constants.DELETE_COMMODITIES_ERROR,
  };
};

export const createCommodity = (data) => {
  return {
    type: constants.CREATE_COMMODITIES,
    data: data,
  };
};

export const createCommoditySuccess = (data) => {
  return {
    type: constants.CREATE_COMMODITIES_SUCCESS,
    data: data,
  };
};

export const createCommodityError = () => {
  return {
    type: constants.CREATE_COMMODITIES_ERROR,
  };
};

export const isAddingAction = (data) => {
  return {
    type: constants.IS_ADDING_UPDATE,
    data,
  };
};
